var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallB(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.226,
    height: 24.602,
    viewBox: "0 0 6.41 6.509",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.516 -89.566)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.145,
    height: 6.245,
    x: 44.648,
    y: 89.699,
    rx: 1,
    ry: 1,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: 0.264583,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 48.204,
    y: 92.627,
    style: {
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "3.49121px",
      fontFamily: "sans-serif",
      fill: "#fff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0872804
    }
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 48.204,
    y: 92.627,
    style: {
      fill: "#fff",
      strokeWidth: 0.0872804
    }
  }, "B"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallB);
export default __webpack_public_path__ + "static/media/small-b.94d6969ef163ca043d472defcc5c23a6.svg";
export { ForwardRef as ReactComponent };